export class FiltrosDesembolso{

    Tipo: number = 0;
    IdAd : string = '';
    IdProv : string = '';
    Estado : string = 'P';
    Moneda : number = 0;
}